export default __webpack_public_path__ + "static/media/hand.40323552.jpg";